import { 
    object as yupObject, 
    string as yupString, 
    boolean as yupBoolean, 
    date as yupDate,
    ref as yupRef
 } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { IOgranizationAddress } from '../../../../@types/profile-types';
import validationMessage from 'util/validations';
import { requiredWithoutSpaces } from 'util/regex.utils';
import startDateEndDateSchema from 'util/getStartDateEndDateSchema';
import OrganisationForm from 'pages/profile/components/OrganisationForm';

export interface IEmploymentFormInputs extends IOgranizationAddress {
    current: boolean;
    department: string;
    title: string;
    startDate: string;
    endDate: string;
    asset_id?: string;
}

export const formDefaults: IEmploymentFormInputs = {
    current: false,
    department: '',
    title: '',
    startDate: '',
    endDate: '',
    asset_id: '',
    ...OrganisationForm.formDefaults
};

const schema = yupObject({
    current: yupBoolean().required(validationMessage.required),
    department: yupString().max(100, validationMessage.max(100)),
    title: yupString().matches(requiredWithoutSpaces(),validationMessage.required).max(100, validationMessage.max(100)).required(validationMessage.required)
}).concat(OrganisationForm.schema).concat(startDateEndDateSchema);

export const formSchemaResolver = yupResolver(schema);